// Dependencies
import { Theme } from '@mui/material';

// Styles
const styles = {
  textarea: (theme: Theme) => ({
    p: 0,
    width: 'calc(100% - 2px)',
    height: 'calc(100% - 2px)',
    border: '1px dashed transparent',
    borderRadius: 1,
    '&:focus': {
      outline: 'none',
      borderColor: theme.palette.common.black,
    },
  }),
};

// Export styles
export default styles;
